<template>
  <div
    class="flex items-center gap-[12px] p-[20px] border-[1.5px] rounded-[8px] mb-[8px] cursor-pointer transition-colors"
    :class="{
      '!border-[#F95031]  hover:!border-[#F95031]' : selected && !disabled,
      '!border-[#E2E2E2]  hover:!border-[#F95031]' : !selected && !disabled,
      '!cursor-not-allowed bg-[#F8F8F8] hover:!border-[#E2E2E2]' : disabled,
    }"
    @click="handleClick"
  >
    <b-checkbox
      v-model="selected"
      :disabled="disabled"
      class="transition-opacity duration-200"
    />
    <div>
      <h5
        class="font-[500] mb-[4px]"
        :class="{'text-[#828282]' : disabled, 'text-[#333333]' : !disabled}"
      >
        Alamat {{ index }}
      </h5>
      <p
        class="text-[#828282] text-[14px] mb-0 overflow-hidden transition-[clip-path,transform,opacity] duration-200 will-change-[clip-path] transform-gpu"
        :class="{
          'line-clamp-1 max-h-[24px] clip-hide': !selected,
          'max-h-[320px] clip-show': selected,
        }"
      >
        {{ data.address || '-' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardStoreAddress',
  props: {
    index: {
      type: Number,
      required: false,
      default: 1,
    },
    data: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.disabled) return
      this.$emit('click', this.data)
    },
  },
}
</script>

<style scoped>
.clip-hide {
  clip-path: inset(0 0 calc(100% - 24px) 0);
  opacity: 0.92;
  transform: translateZ(0) translateY(2px);
}

.clip-show {
  clip-path: inset(0 0 0 0);
  opacity: 1;
  transform: translateZ(0) translateY(0);
}
</style>
